import { PhotoEventWithPricelistAndPhotos } from 'common-models';

export function getDateString(input: Date): string {
  return `${input.getFullYear()}-${String(input.getMonth() + 1).padStart(2, '0')}-${String(input.getDate()).padStart(2, '0')}`;
}

export function getEventDateString(eventWithPricelistAndPhotos: PhotoEventWithPricelistAndPhotos): string {
  if (eventWithPricelistAndPhotos === undefined) {
    return '';
  }

  const startDateString = getDateString(new Date(eventWithPricelistAndPhotos.event.eventStartTime));
  const endDateString = getDateString(new Date(eventWithPricelistAndPhotos.event.eventEndTime));

  return startDateString === endDateString ? startDateString : `${startDateString} - ${endDateString}`;
}

export const setWindowLocation = (newLocation: string): void => {
  if (!window.location.href.endsWith(newLocation)) {
    window.history.pushState({}, '', newLocation);
  }
};

export enum ViewStyle {
  Grid,
  Gallery,
}
